var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal-select',{class:_vm.Info.Dialog.Select.Class,attrs:{"title":_vm.Info.Dialog.Select.Title,"width":600},on:{"init":_vm.handleModal_Init,"submit":_vm.handleModal_Submit},scopedSlots:_vm._u([{key:"search-result",fn:function({ userData }){return [_c('List',{attrs:{"items":_vm.items,"userData":userData}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }